import type { OnlineShareChannel } from '#src/app/pages/starterDashboardV2/shared/types';
import type { ShareAction, ShareChannel } from '#src/app/shared/hooks/share';
import { useAvailableShareActions } from '#src/app/shared/hooks/share';

import type { ShareablePost } from './types';
import { useDashboardShareChannels } from './useDashboardShareChannels';
import { useDashboardShareOptions } from './useDashboardShareOptions';

type OnlineShareAction = ShareAction<OnlineShareChannel>;

export function useDashboardShareActions(
	channel?: OnlineShareChannel,
	previewLinkConfigs?: readonly ShareablePost[],
	customTrackingData?: Array<Record<string, string>>,
	customUtmParams?: Array<Record<string, string>>,
): readonly OnlineShareAction[] {
	const options = useDashboardShareOptions(previewLinkConfigs, customTrackingData, customUtmParams);
	const channels = useDashboardShareChannels();
	return useAvailableShareActions(channel ? [channel] : channels, options);
}

export type DashboardShareAction = ShareAction<ShareChannel>;
